module.exports = __webpack_public_path__ + "images/icons_v2/volume-mute-outlined-da9f0837.svg";